/*
 * @Description:
 * @Author: dezhi
 * @Date: 2019-10-21 16:27:26
 * @LastEditTime: 2021-06-11 09:42:42
 * @LastEditors: dezhi
 */

import axios from 'axios';
import store from '@/store';
import router from '@/router';
import baseConf from './conf';
// axios 配置
axios.defaults.timeout = 50000;
// -------------------baseUrl 配置-----------------------------
axios.defaults.baseURL = baseConf.reqUrl; //请求url 测试
// http request 拦截器
axios.interceptors.request.use(
	(config) => {
		config.headers.X_AUTH_TOKEN = localStorage.getItem('apply_token');
		config.headers.source = baseConf.webSource;
		return config;
	},
	(err) => {
		return Promise.reject(err);
	}
);

// http response 拦截器
axios.interceptors.response.use(
	(response) => {
		if (response.data.status != 2000) {
			// $vma.$message.warning(response.data.message);
		} else if (response.data.status == 5001) {
			store.commit('account/logout');
			router.replace({
				path: '/login',
				query: {
					redirect: router.currentRoute.path
				},
			});
		}
		return response;
	},
	(error) => {
		if (error.response) {
			switch (error.response.status) {
				case 401:
					router.currentRoute.path !== 'login' &&
						router.replace({
							path: '/login',
							query: {
								redirect: router.currentRoute.path
							},
						});
			}
		}
		return Promise.reject(error.response.data);
	}
);

export default axios;